import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { legalPages } from "@/i18n/legal";
import { DEFAULT_LANG } from "@/i18n/detectLanguage";

export default function LegalPage({ doc }) {
  const { lang, t } = useLanguage();
  const pages = legalPages[lang] || legalPages[DEFAULT_LANG];
  const page = pages[doc];
  return (
    <div className="mx-auto min-h-screen w-full max-w-md px-6 pb-16 pt-6" data-testid={`legal-page-${doc}`}>
      <Link
        to="/"
        data-testid="legal-back-home"
        className="inline-flex items-center gap-1.5 text-xs font-medium text-[#1663E6] transition-colors hover:text-[#0B3D91]"
      >
        <ArrowLeft className="h-4 w-4" />
        {t("backHome")}
      </Link>
      <h1 className="mt-6 text-2xl font-bold tracking-tight text-[#0F1E3D]" data-testid="legal-page-title">
        {page.title}
      </h1>
      <div className="mt-3 h-0.5 w-12 rounded-full bg-[#1663E6]" />
      <div className="mt-6 space-y-4">
        {page.paragraphs.map((p, i) => (
          <p key={i} className="text-sm leading-relaxed text-slate-600" data-testid={`legal-paragraph-${i + 1}`}>
            {p}
          </p>
        ))}
      </div>
      <p className="mt-10 text-center text-[11px] text-slate-400" data-testid="legal-last-updated">
        {t("lastUpdated")}
      </p>
      <p className="mt-2 text-center text-[11px] text-slate-400">{t("copyright")}</p>
    </div>
  );
}
